import React from "react";
import { optionMasterService } from "app/_services/OptionMasterService/optionMasterService";
import toastr from "toastr";

import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { DepartmentService } from "app/_services/UserManagement/DepartmentService";
import { RoleService } from "app/_services/RoleService/RoleService";
import { UserService } from "app/_services/UserService/UserService";
import Prompt from "app/Components/IEnergyPrompt/Prompt";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import localStorageService from "app/services/localStorageService";
import FormBtn from "app/Components/CommanComponents/FormBtn";
import { userValidation, userFormLabel } from "./helper";

import FormInput from "app/Components/_form/FormInput/FormInput";
import InputError from "app/Components/_form/InputError/InputError";
import { getAllSites } from "app/_services/ehs/ehsSiteServices";
import { Col, Row } from "react-bootstrap";
import {
  HO_Work_Flow_Role_List,
  MINE_Work_Flow_Role_List,
  RO_Work_Flow_Role_List,
  UserWorkFlowRoleList,
} from "app/_constants/constant";
import UserPermissionCheckbox from "app/Components/_userManagement/UserSiteModal/UserPermissionCheckbox";
import { object } from "yup";
const initialUserPermission = UserWorkFlowRoleList.reduce(
  (prev, next) => ({ ...prev, [next.name]: next.value ?? false }),
  {}
);
class AddUserRegistration extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      error: {},
      userId: this.props.id ? this.props.id : "",
      userData: this.props.setUserData,
      firstName: "",
      lastName: "",
      email: "",
      roleId: "",
      classification: "",
      comapnyId: "",
      departmentId: "",
      contactNumber: "",
      designation: "",
      siteId: null,
      departmentArr: [],
      companyArr: [],
      edit: false,
      changeRoute: "",
      userPermission: { ...initialUserPermission },
      siteType: "",
      auth_user: localStorageService.getItem("auth_user"),
    };
  }

  funModal = () => {
    this.props.modalHide();
    this.props.userPage();
  };

  componentDidMount() {
    this.getDepartmentList();
    this.getRolesList();
    this.getCompanyList();
    this.getSiteList();
    if (this.state.userId) {
      this.setUserData();
    }
  }
  onChangeUserPermission = ({ target: { name, value, type, checked } }) => {
    this.setState({
      userPermission: {
        ...this.state.userPermission,
        [name]: type === "checkbox" ? checked : value,
      },
    });
  };
  async setUserData() {
    let response = await UserService.getUserByID(this.state.userId);
    // console.log("response/***/", response);
    // return;
    if (!response?.status) {
      // this.props.history.push("/user-management/user-registration");
      toastr.error(response?.message || "Something went Wrong");
      return;
    }
    const userData = response.data || {};

    this.setState({
      firstName: userData?.firstName,
      lastName: userData?.lastName,
      email: userData?.email,
      siteId: userData?.siteId,
      siteType: userData?.ehsSite?.siteType,
      roleId: userData?.roleId,
      classification: userData?.classification,
      comapnyId: userData?.comapnyId,
      departmentId: userData?.departmentId,
      contactNumber: userData?.contactNumber,
      userPermission: {
        ...(userData?.accessPermissions || []).reduce(
          (prevPermission, next) => ({
            ...prevPermission,
            [next.permission]: +next.permissionValue ? true : false,
          }),
          {}
        ),
      },
      designation: userData?.designation,
      edit: true,
    });
    console.log(this.state.userPermission);
    return;
  }

  async getRolesList() {
    let response = await RoleService.RoleList();
    if (response && response.status) {
      if (response.data && response.data.roles) {
        let roleArr = response.data.roles;

        if (
          this.state.auth_user &&
          this.state.auth_user.user &&
          this.state.auth_user.user.role
        ) {
          if (this.state.auth_user.user.role.roleLable) {
            let roleLable = this.state.auth_user.user.role.roleLable;
            roleArr = roleArr.filter((data) => data.roleLable > roleLable);
          }
        }
        this.setState({
          roleArr: roleArr.filter((role) => role.status === 1),
        });
      }
    } else {
      this.setState({
        roleArr: [],
      });
    }
  }

  async getSiteList() {
    // let response = await getAllSites("filter[status]=1&filter[activeStatus]=active");
    let response = await getAllSites("filter[status]=1");
    if (!response?.data || !response?.status) return;
    if (response && response.status) {
      if (response.data) {
        let siteList = response.data;
        this.setState({
          siteList: siteList,
        });
      }
    } else {
      this.setState({
        siteList: [],
      });
    }
  }

  setUserPermission = (name, value) => {
    // console.log("/*/**/*/permissionSet", this.state.roleArr.find(d => d.id == value).roleLable);
    // return;
    const permission = this.state.userPermission;
    if (
      name == "roleId" ||
      (name == "siteId" &&
        this.state.siteType !== this.state?.siteList.find((d) => d.id == value)?.siteType)
    ) {
      Object.keys(this.state.userPermission).map((d) => {
        permission[d] = false;
      });
      // console.log("/**/*/*/permission", permission);
    }
    return permission;
  };

  onChange = (e) => {
    const { value, name } = e.target;

    if (name === "classification") {
      const getDepartmentId = (
        classificationValue,
        prevDepartmentId,
        newDepartmentId
      ) => {
        switch (classificationValue) {
          case "":
            return "";
          case "Internal":
            return prevDepartmentId;
          case "External":
            return prevDepartmentId || newDepartmentId || "";
          default:
            return "";
        }
      };
      const department = this.state.departmentArr[0];

      this.setState((prevState) => {
        return {
          ...prevState,
          departmentId: getDepartmentId(value, prevState.departmentId, department?.id),
          changeRoute: 1,
          [name]: value,
        };
      });
    } else
      this.setState({
        [name]: value,
        userPermission:
          name == "roleId" || name == "siteId"
            ? this.setUserPermission(name, value)
            : this.state.userPermission,
        siteType:
          name == "siteId"
            ? this.state.siteList.filter((d) => d.id == value)[0].siteType
            : name == "roleId"
            ? null
            : this.state.siteType,
        siteId: name == "roleId" ? null : name == "siteId" ? value : this.state.siteId,
        changeRoute: 1,
      });
  };

  async getDepartmentList() {
    let response = await DepartmentService.getDepartment();
    if (response && response?.status && response?.data) {
      this.setState({
        departmentArr: response?.data?.departments?.filter((dep) => dep?.status === 1),
      });
    }
  }

  async getCompanyList() {
    let response = await optionMasterService.optionMasterByType("company", 0);

    if (response && response.status) {
      if (response.data && response.data.option_master) {
        this.setState({
          companyArr: response.data.option_master,
        });
      }
    } else {
      this.setState({
        companyArr: [],
      });
    }
  }

  onSubmit = async (e, userData) => {
    e.preventDefault();

    const obj = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      email: this.state.email,
      roleId: this.state.roleId,
      siteId: this.state.siteId,
      classification: this.state.classification,
      comapnyId: this.state.comapnyId,
      departmentId: this.state.departmentId,
      contactNumber: this.state.contactNumber,
      designation: this.state.designation,
      userPermission: this.state.userPermission,
    };

    const errorObj = userValidation(obj);
    // console.log(errorObj);
    // return;
    this.setState((prev) => ({ ...prev, error: errorObj, submitted: true }));

    if (Object.values(errorObj).filter((d) => d !== "").length) return;

    const response = await (this.state.userId
      ? UserService.updateUser(this.state.userId, obj)
      : UserService.addUser(obj));

    if (!response?.status)
      return toastr.warning(response?.message || "Something went Wrong");

    this.setState({ changeRoute: "" });
    toastr.success(
      this.state.userId ? "User Updated Successfully" : "User Created Successfully"
    );
    this.funModal();
    // this.props.history.push("/user-management/user-registration");
  };

  render() {
    let {
      firstName,
      lastName,
      email,
      roleId,
      userData,
      classification,
      comapnyId,
      departmentId,
      designation,
      contactNumber,
      departmentArr,
      companyArr,
      roleArr,
      siteList,
      edit,
      siteId,
      userId,
      error,
      userPermission,
      siteType,
    } = this.state;
    return (
      <div>
        {/* <MainBreadcrumb
          routeSegments={[
            { name: "User Management", path: "#" },
            {
              name: "Users",
              path: "/user-management/user-registration",
            },
            { name: edit ? "Edit" : "Add" },
          ]}
          breadCrumbsText="User_Management_User_Registration"
        /> */}

        <Prompt changes={this.state.changeRoute}></Prompt>

        <div className="row d-flex justify-content-center">
          <div className="col-md-12">
            <div className="card mt-0 mb-3" style={{ overflow: "visible" }}>
              <div className="card-body">
                {/* <div className="simple-card-title">
                  <h3 class="text-capitalize mb-1">{edit ? "Edit" : "Add"} User</h3>
                </div> */}

                {/* <form onSubmit={this.onSubmit}> */}
                <div>
                  <div className="row">
                    <div className="col-md-4 form-group mb-3">
                      <FormInput
                        name={"firstName"}
                        value={firstName}
                        onChange={this.onChange}
                        label={userFormLabel["firstName"]}
                        placeHolder={userFormLabel["firstName"]}
                        error={error["firstName"]}
                      />
                    </div>
                    <div className="col-md-4 form-group mb-3">
                      <FormInput
                        name={"lastName"}
                        value={lastName}
                        onChange={this.onChange}
                        label={userFormLabel["lastName"]}
                        placeHolder={userFormLabel["lastName"]}
                        error={error["lastName"]}
                      />
                    </div>

                    <div className="col-md-4 form-group mb-3">
                      <label>Role</label>

                      <SimpleSelect
                        name="roleId"
                        value={roleId}
                        onChange={this.onChange}
                        options={roleArr}
                        menuPortalTarget={null}
                        id="id"
                        label="title"
                      ></SimpleSelect>

                      <InputError error={error["roleId"]} />
                    </div>

                    <div className="col-md-4 form-group mb-3">
                      {/* <label>Email ID</label>
                      <input
                        name="email"
                        type="email"
                        placeholder="Enter Email Id"
                        className="form-control"
                        value={email}
                        onChange={this.onChange}
                        required
                      /> */}
                      <FormInput
                        name={"email"}
                        value={email}
                        onChange={this.onChange}
                        label={userFormLabel["email"]}
                        placeHolder={userFormLabel["email"]}
                        error={error["email"]}
                      />
                    </div>

                    <div className="col-md-4 form-group mb-3">
                      {/* <label>Mobile Number</label>
                      <input
                        name="contactNumber"
                        type="text"
                        pattern="[789][0-9]{9}"
                        placeholder="Enter Mobile Number"
                        className="form-control"
                        value={contactNumber}
                        onChange={this.onChange}
                        required
                      /> */}

                      <FormInput
                        name={"contactNumber"}
                        value={contactNumber}
                        onChange={this.onChange}
                        label={userFormLabel["contactNumber"]}
                        placeHolder={userFormLabel["contactNumber"]}
                        error={error["contactNumber"]}
                      />
                    </div>
                    {roleId &&
                      roleArr?.find((d) => d.id == roleId && d.roleLable == "7") && (
                        <div className="col-md-4 form-group mb-3">
                          <label>Location</label>

                          <SimpleSelect
                            name="siteId"
                            value={siteId}
                            onChange={this.onChange}
                            id="id"
                            label="name"
                            options={siteList}
                            init="Select"
                            menuPortalTarget={null}
                            disabled={false}
                          ></SimpleSelect>
                          <InputError error={error["siteId"]} />
                        </div>
                      )}
                  </div>
                  <div className="row" style={{ marginLeft: "5px", marginRight: "1px" }}>
                    <UserPermissionCheckbox
                      form={userPermission}
                      onChange={(e) => this.onChangeUserPermission(e)}
                      siteType={siteType || null}
                      title={siteType ? "Permissions" : ""}
                    />
                  </div>

                  <FormBtn
                    id={userId}
                    backBtnTitle={"Cancel"}
                    onSubmit={(event) => this.onSubmit(event, userData)}
                    // backUrl={"/user-management/user-registration"}
                    backOnClick={this.props.modalHide}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddUserRegistration;
